import create from "zustand";

export type ClasswizeTheme = "linewize" | "smoothwall";

export interface ThemeStore {
	theme: ClasswizeTheme;
	setTheme: (theme: ClasswizeTheme) => void;
}

export const useThemeStore = create<ThemeStore>((set) => ({
	theme: "linewize",
	setTheme: (theme) => set(() => ({ theme: theme })),
}));
